export default __webpack_public_path__ + "static/media/blog-default-3.c57236bb.png";